const reviewModal = document.getElementById("editReviewEmployeeModal");
const openModalBtns = document.querySelectorAll(".edit-review-modal");
const closeModalBtns = document.querySelector(".close");

if (reviewModal) {
  openModalBtns.forEach(button => {
    button.addEventListener("click", function () {
      reviewModal.style.display = "block";
    });
  });
 
  closeModalBtns.addEventListener("click", function () {
    reviewModal.style.display = "none";
  });

  window.addEventListener("click", function (event) {
    if (event.target === reviewModal) {
      reviewModal.style.display = "none";
    }
  });
}
